
(function initProductSpotlightConnectors() {
  const DESKTOP_MAX = 989; // matches CSS breakpoint where connectors are hidden
  const sections = document.querySelectorAll('[id^="product-spotlight-"]');
  if (!sections.length) return;

  const centerOf = (el) => {
    if (!el) return null;
    const r = el.getBoundingClientRect();
    return { x: r.left + r.width/2, y: r.top + r.height/2, rect: r };
  };

  const pct = (value, base) => `${(value / base) * 100}%`;

  const redraw = (root) => {
    const grid = root.querySelector('.product-spotlight__grid');
    if (!grid) return;
    const gridR = grid.getBoundingClientRect();
    const isMobile = window.innerWidth <= DESKTOP_MAX;

    // Elements
    const leftConnector  = grid.querySelector('.ps-connector--left');
    const rightConnector = grid.querySelector('.ps-connector--right');

    // Pointers
    const videoPointer = grid.querySelector('.product-spotlight__media--video .product-spotlight__pointer');
    const imagePointer = grid.querySelector('.product-spotlight__media--image .product-spotlight__pointer');
    const ghostLeft    = grid.querySelector('.product-spotlight__pointer--ghost-left');
    const ghostRight   = grid.querySelector('.product-spotlight__pointer--ghost-right');

    // Fallback anchors if a pointer is missing: use centers of respective columns
    const videoCol = grid.querySelector('.product-spotlight__media--video') || grid.querySelector('.product-spotlight__media');
    const imageCol = grid.querySelector('.product-spotlight__media--image') || grid.querySelectorAll('.product-spotlight__media')[1];

    const pVideo = centerOf(videoPointer) || centerOf(videoCol);
    const pImg   = centerOf(imagePointer) || centerOf(imageCol);
    const pGhostL= centerOf(ghostLeft);
    const pGhostR= centerOf(ghostRight);

    if (!pVideo || !pImg || !pGhostL || !pGhostR) return;

    if (isMobile) {
      // CSS already hides connectors; no work needed.
      return;
    }

    // Left connector: line from VIDEO pointer -> LEFT ghost pointer
    if (leftConnector) {
      const x1 = pVideo.x - gridR.left;
      const y1 = pVideo.y - gridR.top;
      const x2 = pGhostL.x - gridR.left;
      const y2 = pGhostL.y - gridR.top;

      // place as a horizontal line whose left = min(x1,x2), width = |x2 - x1|, top = y at source (use average to reduce small vertical mismatch)
      const left = Math.min(x1, x2);
      const width = Math.abs(x2 - x1);
      const top = (y1 + y2) * 0.5;

      leftConnector.style.left  = pct(left,  gridR.width);
      leftConnector.style.width = pct(width, gridR.width);
      leftConnector.style.top   = pct(top,   gridR.height);
    }

    // Right connector: line from RIGHT ghost pointer -> IMAGE pointer
    if (rightConnector) {
      const x1 = pGhostR.x - gridR.left;
      const y1 = pGhostR.y - gridR.top;
      const x2 = pImg.x    - gridR.left;
      const y2 = pImg.y    - gridR.top;

      const left = Math.min(x1, x2);
      const width = Math.abs(x2 - x1);
      const top = (y1 + y2) * 0.5;

      rightConnector.style.left  = pct(left,  gridR.width);
      rightConnector.style.width = pct(width, gridR.width);
      rightConnector.style.top   = pct(top,   gridR.height);
    }
  };

  // Observe size changes of each section grid
  const ro = new ResizeObserver((entries) => {
    entries.forEach((e) => {
      const root = e.target.closest('[id^="product-spotlight-"]') || e.target;
      if (root) redraw(root);
    });
  });

  sections.forEach((sec) => {
    const grid = sec.querySelector('.product-spotlight__grid');
    if (grid) ro.observe(grid);

    const re = () => redraw(sec);
    // events that affect layout
    window.addEventListener('resize', re, { passive: true });
    document.fonts?.ready?.then(re);
    sec.querySelectorAll('img,video').forEach((m) => {
      m.addEventListener('load', re, { once: true });
      m.addEventListener('loadedmetadata', re, { once: true });
      m.addEventListener('loadeddata', re, { once: true });
    });

    // Shopify editor events (safe no-ops outside editor)
    document.addEventListener('shopify:section:load', re);
    document.addEventListener('shopify:section:reorder', re);
    document.addEventListener('shopify:block:select', re);
    document.addEventListener('shopify:block:deselect', re);

    // First draw
    re();
  });
})();